import React from 'react';
import { Accordion } from 'core/controls';
import SummaryFinanceContent from './SummaryFinanceContent';
import SelectedAccessoriesGroup from './SelectedAccessoriesGroup';
import StandardFeaturesGroup from './StandardFeaturesGroup';

const SummaryAccordion = props => {
  const {
    displayIpe,
    accessories,
    standardFeatures,
    loadingFeatures,
    showFinance,
    showLease
  } = props;

  return (
    <Accordion>
      {displayIpe ? (
        <SummaryFinanceContent
          showFinance={showFinance}
          showLease={showLease}
        />
      ) : null}
      <SelectedAccessoriesGroup accessories={accessories} />
      <StandardFeaturesGroup
        standardFeatures={standardFeatures}
        loadingFeatures={loadingFeatures}
      />
    </Accordion>
  );
};

export default SummaryAccordion;
